export const TXP_OPTIONS_V2_FEATURE = 'cal-txp-optionsV2';
export const GRIFFIN_REQUEST_BASEURL = 'txp/api/v1.0/me/{0}';
export const USER_SETTINGS = 'UserSettings';

// Datapoint names

export const TxpSettingsDataPointNames = {
    // name for datapoint which logs TXP loading settings.
    TXPSettingsLoad: 'TxpSettingsLoad',

    //name for datapoint which logs Txp setting response is error.
    TXPSettingsResponseError: 'TXPSettingsResponseError',

    // name for datapoint which logs TXP settings save V2
    TxpSettingsSaveV2: 'TxpSettingsSaveV2',
};
